export class CONSTANT_DEVICE {
  // Last mise à jour 2024-03-19 (api-v-1.3.6.8)
  static device_type = {
    10: "DJI Dock (3-1-0)",
    11: "DJI Dock 2 (3-2-0)",
    12: "DJI Aeroscope mobile",
    13: "DJI Dock 3",

    20: "Matrice 30 (M30) (0-67-0)",
    21: "Matrice 30T (M30T) (0-67-1)",
    22: "Matrice 3D (M3D) (0-91-0)",
    23: "Matrice 3D (M3TD) (0-91-1)",

    24: "Matrice 4D (98-0-0)",
    25: "Matrice 4T (89-0-0)",
    26: "Matrice 4E(88-0-0)",
    27: "Matrice 4TD(99-0-0)",

    30: "FTS",
    40: "Router",
    50: "WatchCam (RTSP Dlink)",
    55: "Drone (RTMP)",
    60: "DJI RC Plus-rc-M30/M30T Remote Controller (2-119-0)",
    110: "Matrice 350 RTK (0-89-0)",
    120: "Matrice 300 RTK (M300 RTK)(0-60-0)",
    130: "Mavic 3 Enterprise Series (M3E) (0-77-0)",
    140: "Mavic 3 Enterprise Series (M3T) (0-77-1)",
    150: "Mavic 3M (M3M) (0-77-2)",

    160: "Z30 camera (1-20-0)",
    170: "XT2 camera (1-26-0)",
    180: "FPV camera (1-39-0)",
    190: "XTS camera (1-41-0)",
    200: "H20 camera (1-42-0)",
    210: "H20T camera (1-43-0)",
    220: "M30 camera (1-52-0)",
    221: "M3D camera (1-80-0)",
    230: "M30T camera (1-53-0)",
    231: "M3TD camera (1-81-0)",
    240: "H20N camera (1-61-0)",
    250: "DJI Dock camera (1-165-0)",
    260: "M3E camera (1-66-0)",
    270: "M3T camera (1-67-0)",
    280: "M3M camera (1-68-0)",
    285: "M4 camera (1-98-0)",
    286: "M4T camera (1-89-0)",
    290: "DJI RC-rc-M300 RTK Remote Controller (2-56-0)",
    300: "DJI RC Pro Enterprise-rc-M3E/M3T, M3M Remote Controller (2-144-0)",
    310: "DJI RC Pro Enterprise 2 -rc- M4D/M4TD",
    1020: "Autel EVO MAX 4N",
    1021: "Autel EVO MAX 4T",
    1060: "Autel Smart Controller V3",
  }

  static device_image = {
    10: "DJI_Dock_1.png",
    11: "DJI_Dock_2.png",
    12: "Aeroscope.svg",
    13: "DJI_Dock_2.png",
    20: "Matrice_30.png",
    21: "Matrice_30.png",
    22: "DJI_Matrice_3D.png",
    23: "DJI_Matrice_3D.png",
    24: "DJI_Matrice_3D.png",
    25: "DJI_Matrice_3D.png",
    30: "Parachute.svg",
    40: "Router.svg",
    50: "Watchcam.svg",
    55: "Drone_externe.svg",
    60: "DJI_RC_2.png",
    110: "Matrice_350_RTK.png",
    120: "Matrice_300_RTK.png",
    130: "Mavic_3_Entreprise.png",
    140: "Mavic_3_Entreprise.png",
    150: "Mavic_3_Entreprise.png",
    // 160: "Z30 camera (1-20-0)",
    // 170: "XT2 camera (1-26-0)",
    // 180: "FPV camera (1-39-0)",
    // 190: "XTS camera (1-41-0)",
    // 200: "H20 camera (1-42-0)",
    // 210: "H20T camera (1-43-0)",
    // 220: "M30 camera (1-52-0)",
    // 221: "M3D camera (1-80-0)",
    // 230: "M30T camera (1-53-0)",
    // 231: "M3TD camera (1-81-0)",
    // 240: "H20N camera (1-61-0)",
    // 250: "DJI Dock camera (1-165-0)",
    // 260: "M3E camera (1-66-0)",
    // 270: "M3T camera (1-67-0)",
    // 280: "M3M camera (1-68-0)",
    290: "DJI_RC_2.png",
    300: "DJI_RC_2.png",
    310: "DJI_RC_2.png",
    1020: "DJI_Matrice_3D.png", //A changer "Autel EVO MAX 4N",
    1021: "DJI_Matrice_3D.png", //A changer "Autel EVO MAX 4T",
    1060: "DJI_RC_2.png", //A changer "Autel Smart Controller V3",
  }

  static device_type_domain = {
    //Drone

   // 110: { name :"Matrice 350 RTK",code:{"domain":0, "type":89, "sub_type":0}},
   // 120: { name :"Matrice 300 RTK (M300 RTK)", code:{"domain":0, "type":60, "sub_type":0}},
    20: { name :"Matrice 30 (M30)", code:{"domain":0, "type":67, "sub_type":0}, key :'M30', keyCamera : 220 },
    21: { name :"Matrice 30T (M30T)", code:{"domain":0, "type":67, "sub_type":1}, key :'M30T' , keyCamera : 230},
    22: { name :"Matrice 3D (M3D)", code:{"domain":0, "type":91, "sub_type":0}, key :'M3D' , keyCamera : 221 },
    23: { name :"Matrice 3D (M3TD)", code:{"domain":0, "type":91, "sub_type":1}, key :'M3TD' , keyCamera : 231 },
    24: { name :"Matrice 4 / 4D", code:{"domain":0, "type":98, "sub_type":0}, key :'M4' , keyCamera : 285 },
    25: { name :"Matrice 4T / 4TD", code:{"domain":0, "type":89, "sub_type":0}, key :'M4T' , keyCamera : 286 },
    130: { name :"Mavic 3 Enterprise Series (M3E)", code:{"domain":0, "type":77, "sub_type":0}, key :'Mavic', keyCamera : 260  },
    140: { name :"Mavic 3 Enterprise Series (M3T)", code:{"domain":0, "type":77, "sub_type":1}, key :'Mavic' , keyCamera : 270 },
   // 150: { name :"Mavic 3M (M3M)",code:{"domain":0, "type":77, "sub_type":2}},
    //1020: { name :"Autel EVO MAX 4N", code:{"domain":0, "type":10053, "sub_type":0}},
    //1021: { name :"Autel EVO MAX 4T", code:{"domain":0, "type":10052, "sub_type":0}},


    //Payload
    160: { name :"Z30 camera", code:{"domain":1, "type":20, "sub_type":0}},
    170: { name :"XT2 camera", code:{"domain":1, "type":26, "sub_type":0}},
    180: { name :"FPV camera", code:{"domain":1, "type":39, "sub_type":0}},
    190: { name :"XTS camera", code:{"domain":1, "type":41, "sub_type":0}},
    200: { name :"H20 camera", code:{"domain":1, "type":42, "sub_type":0}},
    210: { name :"H20T camera", code:{"domain":1, "type":43, "sub_type":0}},
    220: { name :"M30 camera", code:{"domain":1, "type":52, "sub_type":0}},
    230: { name :"M30T camera", code:{"domain":1, "type":53, "sub_type":0}},
    240: { name :"H20N camera", code:{"domain":1, "type":61, "sub_type":0}},
    260: { name :"M3E camera", code:{"domain":1, "type":66, "sub_type":0}},
    270: { name :"M3T camera", code:{"domain":1, "type":67, "sub_type":0}},
    280: { name :"M3M camera", code:{"domain":1, "type":68, "sub_type":0}},
    285: { name :"M4 camera", code:{"domain":1, "type":98, "sub_type":0}},
    286: { name :"M4T camera", code:{"domain":1, "type":89, "sub_type":0}},
    221: { name :"M3D camera", code:{"domain":1, "type":80, "sub_type":0}},
    231: { name :"M3TD camera",code:{"domain":1, "type":81, "sub_type":0}},
    250: { name :"DJI Dock camera", code:{"domain":1, "type":165, "sub_type":0}},

    //Remote Controller
    290: { name :"DJI RC-rc-M300 RTK Remote Controller", code:{"domain":2, "type":56, "sub_type":0}},
    60: { name :"DJI RC Plus-rc-M30/M30T Remote Controller",code:{"domain":2, "type":119, "sub_type":0}},
    300: { name :"DJI RC Pro Enterprise-rc-M3E/M3T, M3M Remote Controller", code:{"domain":2, "type":144, "sub_type":0}},
    //1060: { name :"Autel Smart Controller V3", code:{"domain":2, "type":144, "sub_type":0}},

    //DJI Dock
    10: { name :"DJI Dock", code:{"domain":3, "type":1, "sub_type":0}},
    11: { name :"DJI Dock 2", code:{"domain":3, "type":2, "sub_type":0}},
    13: { name :"DJI Dock 3", code:{"domain":3, "type":2, "sub_type":0}},
  }

  static device_controller = {
    10: "Dock",
    11: "Dock II",
    12: "DJI Aeroscope mobile",
    13: "Dock 3",
    30: "FTS",
    50: "WatchCam",
    55: "Drone (RTMP)",
    60: "RC+",
    290: "RC M300",
    300: "RC Pro",
    310: "RC Pro - M4D/M4TD",
    1060: "Autel Smart Controller V3"
  }

  static device_controller_without_slave = {
    50: "WatchCam",
    55: "Drone (RTMP)",
    12: "DJI Aeroscope mobile",
    30: "Parachute",
  }

  static device_watchcam = {
    50: "WatchCam",
  }

  static device_drone_externe = {
    55: "Drone (RTMP)"
  }

  static device_drone = {
    20: "M30",
    21: "M30T",
    22: "M3D",
    23: "M3TD",
    24: "Matrice 4D",
    25: "Matrice 4T",
    26: "Matrice 4E",
    27: "Matrice 4TD",
    110: "M350",
    120: "M300",
    130: "M3E",
    140: "M3T",
    150: "M3M",
    1020: "Autel EVO MAX 4N",
    1021: "Autel EVO MAX 4T",
  }

  static device_drone_measuretarget = {
    20: "M30",
    21: "M30T",
    24: "Matrice 4D",
    25: "Matrice 4T",
    26: "Matrice 4E",
    27: "Matrice 4TD",
  }

  static device_parachute = {
    30: "FTS",
  }

  static device_payload = {
    110:{ // "M350",
      160: "Z30",
      170: "XT2",
      180: "FPV",
      190: "XTS",
      200: "H20",
      210: "H20T",
      220: "M30",
      230: "M30T",
      240: "H20N",
      260: "M3E",
      270: "M3T",
      280: "M3M",
      221: "M3D",
      231: "M3TD",
      250: "DJI Dock",
    },
    120:{ // "M300",
      160: "Z30",
      170: "XT2",
      180: "FPV",
      190: "XTS",
      200: "H20",
      210: "H20T",
      220: "M30",
      230: "M30T",
      240: "H20N",
      260: "M3E",
      270: "M3T",
      280: "M3M",
      221: "M3D",
      231: "M3TD",
      250: "DJI Dock",
    },
  }

  static device_can_play_mission = {
    10: true,
    11: true,
    13: true,
  }

  static device_dock_type = {
    10: "Dock",
    11: "Dock II",
    13: "Dock 3",
  }

  static device_rc_type = {
    60: "RC+",
    290: "RC M300",
    300: "RC Pro",
    310: "RC Pro 2",
    1060: "Autel Smart Controller V3"
  }

  static device_aeroscope = {
    12: "DJI Aeroscope mobile"
  }

  static device_master_can_have_parachute = {
    ...this.device_dock_type,
    ...this.device_rc_type
  }

  static device_master_can_have_watchcam = {
    ...this.device_dock_type,
  }

  static device_master_can_have_router = {
    // 10: true,
    // 11: true,
  }

  /** -------------------------- */

  static get(){
    return {
      device_type: this.device_type,
      device_image: this.device_image,
      device_controller: this.device_controller,
      device_controller_without_slave: this.device_controller_without_slave,
      device_drone_externe: this.device_drone_externe,
      device_watchcam: this.device_watchcam,
      device_drone: this.device_drone,
      device_drone_measuretarget: this.device_drone_measuretarget,
      device_parachute: this.device_parachute,
      device_payload: this.device_payload,
      device_can_play_mission: this.device_can_play_mission,
      device_dock_type: this.device_dock_type,
      device_rc_type: this.device_rc_type,
      device_aeroscope: this.device_aeroscope,
      device_type_domain: this.device_type_domain,
      device_master_can_have_parachute: this.device_master_can_have_parachute,
      device_master_can_have_watchcam: this.device_master_can_have_watchcam,
      device_master_can_have_router: this.device_master_can_have_router,
    }
  }
}
